import { render, staticRenderFns } from "./FundCustomers.vue?vue&type=template&id=2b3781e4&scoped=true"
import script from "./FundCustomers.vue?vue&type=script&lang=js"
export * from "./FundCustomers.vue?vue&type=script&lang=js"
import style0 from "./FundCustomers.vue?vue&type=style&index=0&id=2b3781e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3781e4",
  null
  
)

export default component.exports